var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuehelpfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M27 33.9c-1.2 1.2-2.8 1.9-4.7 1.9h-8.4c-3.7 0-6.6-3-6.6-6.6v-8.4c0-1.4.4-2.6 1.1-3.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M20.6 29H28c3.7 0 6.6-3 6.6-6.6v-8.7c0-3.7-3-6.6-6.6-6.6h-7.4c-3.7 0-6.6 3-6.6 6.6v8.7c0 3.6 2.9 6.6 6.6 6.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 24.3,
    cy: 18.1,
    r: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuehelpfilled);
export default __webpack_public_path__ + "static/media/valuehelpfilled.88028e250f6f54d503dd3bd0f56bc27e.svg";
export { ForwardRef as ReactComponent };